<!-- components/EditForm.vue -->
<template>
    <div class="edit-form">
        <el-form ref="form" :model="form" label-width="80px" :rules="rules">
            <el-form-item label="订单来源" prop="Typeform">
                <el-select :disabled="isDisabled" clearable v-model="form.Typeform" placeholder="请选择订单来源">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="创建时间" prop="Creatordertime" v-show="typePage == 'look'">
                <el-date-picker style="width: 100%;" class="je_div" :disabled="isDisabled" v-model="form.Creatordertime"
                    type="datetime" placeholder="选择日期时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="订单状态" prop="Orderstate" v-show="typePage == 'look'">
                <el-input :disabled="isDisabled" v-model="form.Orderstate"></el-input>
            </el-form-item>
            <el-form-item label="金额" prop="Howmuch">
                <el-input-number :disabled="isDisabled" v-model="form.Howmuch" :min="1" :max="999" label="金额"
                    class="je_div"></el-input-number>
            </el-form-item>
            <el-form-item label="备注" prop="Remarks">
                <el-input :disabled="isDisabled" v-model="form.Remarks" placeholder="请输入备注"></el-input>
            </el-form-item>
            <el-form-item label="创建人" prop="Creatuser" v-show="typePage == 'look'">
                <el-input :disabled="isDisabled" v-model="form.Creatuser"></el-input>
            </el-form-item>
            <el-form-item label="操作人" prop="Operationuser" v-show="typePage == 'look'">
                <el-input :disabled="isDisabled" v-model="form.Operationuser"></el-input>
            </el-form-item>
            <el-form-item label="授权码" prop="LicenseKey" v-show="typePage == 'look'">
                <el-input :disabled="isDisabled" v-model="form.LicenseKey"></el-input>
            </el-form-item>
            <el-form-item label="申请人" prop="ApplicationUser">
                <el-input :disabled="isDisabled" v-model="form.ApplicationUser" placeholder="请输入申请人"></el-input>
            </el-form-item>

            <div class="button-div">
                <el-button type="primary" @click="submitData" v-show="typePage == 'add'">提交</el-button>
                <el-button type="primary" @click="copyID" class="copy-id" v-show="typePage == 'look'">复制ID</el-button>
                <el-button type="primary" @click="copyAuthorizationCode" class="copy-authorization-code"
                    v-show="typePage == 'look'">复制授权码</el-button>
                <el-button @click="close">关闭</el-button>
            </div>
        </el-form>
    </div>
</template>

<script>
import request from '@/utils/request' // 就写这一行
import { appCreatOrderConfig } from './mainSTconfig';
import ClipboardJS from 'clipboard';

export default {
    name: 'AppCreatOrder',
    props: {
        typePage: {
            type: String,
            default: 'look',  // add look
            validator: (value) => {
                // 只允许 'add' 和 'look' 这两个值
                return ['add', 'look'].includes(value);
            }
        },
        Datas: {
            type: Object,
            default: () => ({})  // {}
        }
    },
    data() {
        return {
            form: {
                'Typeform': '',
                'Creatordertime': '',
                'Orderstate': '',
                'Howmuch': '',
                'Remarks': '',
                'Creatuser': '',
                'Operationuser': '',
                'LicenseKey': '',
                'ApplicationUser': ''
            },
            rules: {
                Typeform: [
                    { required: true, message: '请选择订单来源', trigger: 'blur' }
                ],
                Creatordertime: [
                    { required: false, message: '', trigger: 'blur' }
                ],
                Orderstate: [
                    { required: false, message: '', trigger: 'blur' }
                ],
                Howmuch: [
                    { required: true, message: '请输入金额', trigger: 'blur' }
                ],
                Remarks: [
                    { required: true, message: '请输入备注', trigger: 'blur' }
                ],
                Creatuser: [
                    { required: false, message: '', trigger: 'blur' }
                ],
                Operationuser: [
                    { required: false, message: '', trigger: 'blur' }
                ],
                LicenseKey: [
                    { required: false, message: '', trigger: 'blur' }
                ],
                ApplicationUser: [
                    { required: true, message: '请输入申请人', trigger: 'blur' }
                ]
            },
            isDisabled: true,
            options: appCreatOrderConfig.typeform_select,
            clipboard: null,
            clipboard_ac: null
        }
    },
    methods: {
        close() {
            this.clearCopy();
            this.$emit('close');
        },
        async submitData() {
            const { Typeform, Howmuch, Remarks, ApplicationUser } = this.form;
            if (!Typeform || !Howmuch || !Remarks || !ApplicationUser) {
                this.$messageX.xiaoxiti("w", "请完善必输项后再次提交！");
                return;
            }
            if (Howmuch == 0) {
                this.$messageX.xiaoxiti("w", "金额不能为0！");
                return;
            }
            try {
                // 自动带 Token，自动处理错误
                const res = await request.post('/CreationOrder', {
                    userName: this.form.ApplicationUser,
                    Howmuch: this.form.Howmuch,
                    Remarks: this.form.Remarks,
                    Typeform: this.form.Typeform
                });

                // 如果代码能走到这里，说明 HTTP 200 且 后端 success=true
                this.$messageX.xiaoxiti("c", res.message);
                this.$emit('save', res.response);
                this.close();

            } catch (err) {
                // 如果出错 (HTTP 401/500 或 后端 success=false)，会进这里
                this.emptyShow = true;
                console.log('失败:', err)
                if (err.response.data.message) {
                    this.$messageX.xiaoxiti("e", err.response.data.message);
                } else {
                    this.$messageX.xiaoxiti("e", err.message);
                }
            }
        },
        lookup() {
            Object.assign(this.form, this.Datas);
        },
        initClipboard() {
            this.clipboard = new ClipboardJS('.copy-id', {
                text: () => this.form.ID // 返回要复制的文本
            });

            this.clipboard_ac = new ClipboardJS('.copy-authorization-code', {
                text: () => this.form.LicenseKey // 返回要复制的文本
            });

            this.clipboard.on('success', (e) => {
                this.$message.success('ID已复制到剪贴板！');
                e.clearSelection();
            });

            this.clipboard.on('error', (e) => {
                console.error('复制失败:', e);
                this.$message.error('复制失败，请手动复制');
            });

            this.clipboard_ac.on('success', (e) => {
                this.$message.success('授权码已复制到剪贴板！');
                e.clearSelection();
            });

            this.clipboard_ac.on('error', (e) => {
                console.error('复制失败:', e);
                this.$message.error('复制失败，请手动复制');
            });
        },
        clearCopy() {
            if (this.clipboard) {
                this.clipboard.destroy(); // 销毁实例，移除事件监听
                this.clipboard = null;    // 释放引用
            }
            if (this.clipboard_ac) {
                this.clipboard_ac.destroy();
                this.clipboard_ac = null;
            }
        }
    },
    mounted() {
        document.getElementsByClassName("modal-container")[0].style.width = "100%";
        this.initClipboard();
        if (this.typePage == 'add') {
            this.isDisabled = false;
        } else {
            this.isDisabled = true;
            this.lookup();
        }
    },
    beforeUnmount() {
        this.clearCopy();
    },
}
</script>

<style scoped>
.edit-form input {
    display: block;
    margin-bottom: 10px;
    padding: 6px;
}

.button-div {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
    padding-bottom: 15px;
}

.je_div {
    width: 100% !important;
}
</style>